import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthLayout from './AuthLayout';
import { authService } from '../services/api';

export default function PasswordRecoveryPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => String(searchParams.get('token') || '').trim(), [searchParams]);
  const qsEmail = useMemo(() => String(searchParams.get('email') || '').trim(), [searchParams]);

  const [email, setEmail] = useState(qsEmail);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (qsEmail) setEmail(qsEmail);
  }, [qsEmail]);

  const handleRequestLink = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      await authService.forgotPassword(email);
      setMessage('Si el correo existe, recibirás un enlace para crear una nueva contraseña.');
    } catch (err) {
      setError(err?.response?.data?.error || err?.message || 'No se pudo enviar el enlace');
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (!newPassword || newPassword.length < 8) {
      setError('La nueva contraseña debe tener al menos 8 caracteres.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden.');
      return;
    }
    setLoading(true);
    try {
      await authService.resetPassword(token, newPassword);
      setMessage('Tu contraseña fue actualizada correctamente. Ya puedes iniciar sesión.');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(err?.response?.data?.error || err?.message || 'No se pudo actualizar la contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title={token ? 'Crear nueva contraseña' : 'Recuperar contraseña'}
      subtitle={token ? 'Define una nueva clave para volver a entrar.' : 'Te enviaremos un enlace para crear una nueva contraseña.'}
    >
      {error ? <div className="error-message">{error}</div> : null}
      {message ? <div className="success-message">{message}</div> : null}

      {token ? (
        <form onSubmit={handleResetPassword} className="space-y-5">
          <div className="form-group">
            <label htmlFor="newPassword" className="label">Nueva contraseña</label>
            <input
              id="newPassword"
              type="password"
              required
              minLength={8}
              autoComplete="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Ingresa tu nueva contraseña"
              className="input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirmPassword" className="label">Confirmar contraseña</label>
            <input
              id="confirmPassword"
              type="password"
              required
              minLength={8}
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Repite la nueva contraseña"
              className="input"
            />
          </div>
          <button type="submit" disabled={loading} className="btn btn-primary w-full" style={{ width: '100%', padding: '0.85rem' }}>
            {loading ? 'Actualizando...' : 'Guardar nueva contraseña'}
          </button>
          <button type="button" onClick={() => navigate('/')} className="btn btn-secondary w-full" style={{ width: '100%', padding: '0.85rem' }}>
            Volver al login
          </button>
        </form>
      ) : (
        <form onSubmit={handleRequestLink} className="space-y-5">
          <div className="form-group">
            <label htmlFor="email" className="label">Correo electrónico</label>
            <input
              id="email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com"
              className="input"
            />
          </div>
          <button type="submit" disabled={loading} className="btn btn-primary w-full" style={{ width: '100%', padding: '0.85rem' }}>
            {loading ? 'Enviando...' : 'Enviar enlace'}
          </button>
          <button type="button" onClick={() => navigate('/')} className="btn btn-secondary w-full" style={{ width: '100%', padding: '0.85rem' }}>
            Volver al login
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
